@if (exchangeRates.length) {
    <div
        (mouseleave)="closeDropdown()"
        class="relative inline-block text-left"
    >
        <div>
            <button
                (click)="toggleDropdown()"
                (mouseenter)="isOpen.set(true)"
                class="inline-flex w-full items-center px-2 py-2 text-white lg:px-4"
            >
                {{ displayLabel }}
                <app-dropdown-arrow
                    [isOpen]="isOpen()"
                    class="ml-1"
                ></app-dropdown-arrow>
            </button>
        </div>

        @if (isOpen()) {
            <div
                aria-labelledby="currency-menu"
                aria-orientation="vertical"
                class="absolute right-0 z-50 max-h-80 w-56 origin-top-right overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
            >
                <div class="py-1" role="none">
                    <a
                        (click)="selectCurrency('')"
                        class="block cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                        [class.font-bold]="!selectedCurrency"
                        role="menuitem"
                    >
                        {{ getSymbol(defaultCurrency) }} {{ defaultCurrency }}
                    </a>
                    @for (rate of exchangeRates; track rate.currency) {
                        <a
                            (click)="selectCurrency(rate.currency)"
                            class="block cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                            [class.font-bold]="selectedCurrency === rate.currency"
                            role="menuitem"
                        >
                            {{ getSymbol(rate.currency) }} {{ rate.currency }}
                        </a>
                    }
                </div>
            </div>
        }
    </div>
}
